import { api } from "../../utills/api";

export const withdrawalApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWithdrawal: build.mutation<{ data: any }, any>({
      query: (params) => ({
        url: "/withdrawal",
        body: params,
        method: "POST",
      }),
    }),
    getMerchantWithdrawal: build.mutation<any, any>({
      query: (params) => ({
        url: "/merchant/withdrawal",
        body: params,
        method: "POST",
      }),
    }),
    AddWithdrawal: build.mutation<{ data: any }, any>({
      query: (params) => ({
        url: "/withdrawal/single/request",
        body: params,
        method: "POST",
      }),
    }),

    ResendWebhook: build.mutation<{ data: any }, any>({
      query: (params) => ({
        url: "/withdrawal/ResendWebhook",
        body: params,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetWithdrawalMutation,
  useGetMerchantWithdrawalMutation,
  useAddWithdrawalMutation,
  useResendWebhookMutation,
} = withdrawalApi;
export const {
  endpoints: { getWithdrawal, AddWithdrawal, ResendWebhook },
} = withdrawalApi;
